const API_BASE = '%%API_BASE%%';
const AUTH_URL = `${API_BASE}auth`;
const DCM_DATA_URL = `${API_BASE}api/getMediaData/`; // Media tiles and charts
const PACING_DATA_URL = `${API_BASE}api/getPacingData/`; // Media pacing table
const WEBSITE_ANALYTICS_URL = `${API_BASE}api/getAnalyticsData`; // Website tiles
const MEDIA_SOURCES_URL = `${API_BASE}api/getMediaSources/`;
const NOTIFICATIONS_URL = `${API_BASE}api/getNotifications/`;
const EXPORT_URL = `${API_BASE}api/export/`;

// const ALL_SOURCES_PARAM = 'sources=all';

const urls = {
    API_BASE,
    AUTH_URL,
    DCM_DATA_URL,
    PACING_DATA_URL,
    WEBSITE_ANALYTICS_URL,
    MEDIA_SOURCES_URL,
    NOTIFICATIONS_URL,
    EXPORT_URL,
};

const colors = {
    fonts: {
        kpmgBlue: '#00338d',
    },
    Clicks: {
        line: '#009a44',
        backgroundColor: 'transparent',
    },
    Impressions: {
        line: '#cecece',
        backgroundColor: '#a8a8a840', // #RRGGBBAA
    },
    'CTR %': {
        line: '#005eb8',
        backgroundColor: 'transparent',
    },
};

export {
    urls,
    colors,
};



// WEBPACK FOOTER //
// ./src/util/config.js